import React from 'react';
import { connect as reduxConnect } from 'react-redux';
import organizationActions from '../../../actions/organization';

const renderWrappedComponent = Component =>
  // eslint-disable-next-line react/prefer-stateless-function
  class extends React.Component {
    componentDidMount= () => {
      // eslint-disable-next-line react/prop-types
      const { organizationTransferToken, setOrganizationsValue } = this.props;
      if (!organizationTransferToken) {
        setOrganizationsValue('openDeclineOrganizationTransferSuccessModal', false);
      }
    }

    handleClose = () => {
      // eslint-disable-next-line react/prop-types
      const { setOrganizationsValue } = this.props;
      setOrganizationsValue('openDeclineOrganizationTransferSuccessModal', false);
      setOrganizationsValue('organizationTransferToken', '');
    }

    render() {
      // eslint-disable-next-line
      const { organizationTransferToken, openDeclineOrganizationTransferSuccessModal, selectedInvite } = this.props;
      return (<Component
        // eslint-disable-next-line
        open={(organizationTransferToken || selectedInvite.uuid) && openDeclineOrganizationTransferSuccessModal}
        onClose={this.handleClose}
        {...this.props}
      />);
    }
  };


const mapStateToProps = ({ organizationInvites }) => ({
  openDeclineOrganizationTransferSuccessModal:
    organizationInvites.openDeclineOrganizationTransferSuccessModal,
  organizationTransferToken: organizationInvites.organizationTransferToken,
  selectedInvite: organizationInvites.selectedInvite,
});

const connect = WrappedComponent =>
  reduxConnect(mapStateToProps, {
    setOrganizationsValue: organizationActions.setOrganizationsValue,
  })(renderWrappedComponent(WrappedComponent));

export default connect;
